<template>
<div>
  <div>
    <span class="title">{{"费用填报："}}</span>
  </div>
  <el-table
      ref="singleTableRef"
      :data="reimburseItems"
      style="width: 100%"
      height="350px"
  >
    <el-table-column type="index" width="40" />
    <el-table-column property="itemName" label="项目" width="150">
<!--      <template #default="scope">
        <el-select
            v-model="scope.row.item"
            placeholder="请选择"
            size="small"
            style="width: 100%">
          <el-option
              v-for="item in reimburseTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"/>
        </el-select>
      </template>-->
    </el-table-column>
    <el-table-column property="money" label="金额（元）" width="140">
      <template #default="scope">
        <el-input-number :disabled="this.readOnly" style="width: 100%;"
                         @change="countAll" size="small" v-model="scope.row.money" :min="0"
                         controls-position="right" step="1000" precision="2"/>
      </template>
    </el-table-column>
    <el-table-column property="remark" label="备注">
      <template #default="scope">
        <el-input :disabled="this.readOnly" v-model="scope.row.remark" type="area"/>
      </template>
    </el-table-column>
<!--    <el-table-column align="right" width="75">
      <template #default="scope">
        <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.row.id)"
        >删除</el-button>
      </template>
    </el-table-column>-->
  </el-table>
  <div class="center">{{"合计：" + this.totalMoneyStr}}</div>
  <div>
    <span class="title">{{"成本分摊："}}</span>
  </div>
  <el-table
      ref="singleTableRef"
      :data="companyItems"
      style="width: 100%"
      height="300px"
  >
    <el-table-column type="index" width="40" />
    <el-table-column property="name" label="客户/公司" min_width="150">
    </el-table-column>
    <el-table-column property="money" label="金额（元）" width="140">
      <template #default="scope">
        <el-input-number :disabled="this.readOnly" style="width: 100%;"
                         size="small" @change="countCompanyAll"
                         v-model="scope.row.money" :min="0"
                         controls-position="right" step="1000" precision="2"/>
      </template>
    </el-table-column>
    <el-table-column property="remark" label="备注">
      <template #default="scope">
        <el-input :disabled="this.readOnly" v-model="scope.row.remark" type="area"/>
      </template>
    </el-table-column>
  </el-table>
  <div class="center">{{"合计：" + this.totalCompanyMoneyStr}}</div>
  <div class="center" v-if="!this.readOnly"><el-button type="primary" :loading="loading" @click="addReimburse">保存</el-button></div>
</div>
</template>

<script>
export default {
  name: "PrcBusinessReimburse",
  inject: ['$fn'],
  props: {
     parentData: {
       type: Object,
       default() {
        return {}
       }
     },
  },
  data(){
    return{
      reimburseItems:[],
      companyItems:[],
      totalMoney:0,
      totalCompanyMoney:0,
      loading:false,
      readOnly:false,
      totalMoneyStr:'',
      totalCompanyMoneyStr:''
    }
  },
  computed: {
    reimburseTypeList() {
      return this.$store.getters['core/getDictList']('reimburse_type');
    },
  },
  watch:{
    totalMoney(value){
      this.totalMoneyStr = this.formatMoney(value)
    },
    totalCompanyMoney(value){
      this.totalCompanyMoneyStr = this.formatMoney(value)
    }
  },
  methods:{
    addItem(itemValue,itemName){
      let item = {
        id: Date.now(),
        item:itemValue,
        itemName:itemName,
        money:0,
        remark:''
      }
      this.reimburseItems.push(item)
    },
    handleDelete(res){
      let delIndex
      this.reimburseItems.forEach((item,index)=>{
       if (item.id === res){
         delIndex = index
       }
      })
      this.reimburseItems.splice(delIndex,1)
    },
    countAll(){
      this.totalMoney = 0
      this.reimburseItems.forEach((item)=>{
        this.totalMoney = (item.money * 100 + this.totalMoney*100)/100
      })
      this.companyItems.forEach((item)=>{
        item.money = Math.ceil(this.totalMoney / this.companyItems.length * 100) / 100
      })
      this.countCompanyAll()
    },
    countCompanyAll(){
      this.totalCompanyMoney = 0
      this.companyItems.forEach((item)=>{
        this.totalCompanyMoney += item.money
      })
    },
    async getCompany(){
      this.companyItems = await this.$http('busPrcService.getCompanyByPrcTaskId', this.parentData)
    },
    async addReimburse(){
      let data = {
        id:this.parentData.id,
        total_money:this.totalMoney,
        reimburse_item:JSON.stringify(this.reimburseItems),
          cost_item:JSON.stringify(this.companyItems),
      }
      this.loading = true
      await this.$http('busPrcService.addPrcReimburse',data).then(()=>{
        this.$message.success("保存成功！")
        this.$fn.closeWindow();
        this.loading = false
      })

    },
    formatMoney(value){
      if (value === 0){
        return '0.00'
      }
      return value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');//使用正则替换，每隔三个数加一个','
    }
  },
  created() {
    console.log(this.parentData)
    this.reimburseTypeList.forEach((item)=>{
      this.addItem(item.value,item.name)
    })

    if (this.parentData.button_id === "prc_business_trip_feedback_reimburse") {
      this.getCompany()
    }

    if (this.parentData.cost_item !== null && this.parentData.cost_item !== undefined){
      this.companyItems = JSON.parse(this.parentData.cost_item)
      this.totalMoney = this.parentData.total_money
      this.readOnly = true
    }
    if (this.parentData.reimburse_item !== null && this.parentData.reimburse_item !== undefined){
      this.reimburseItems = JSON.parse(this.parentData.reimburse_item)
      this.totalCompanyMoney = this.parentData.total_money
      this.readOnly = true
    }
  }
}
</script>

<style scoped>
.title{
  font-size: 16px;
  font-weight: bold;
}
.center{
  display: flex;
  justify-content: center
}
</style>